import { SERVER_ORIGIN, StoreName } from "constants/serviceWorker";
import BaseCustomDeleteResponse from "./BaseCustomDeleteResponse";
import CustomResponseTaskType from "./CustomResponseTaskType";
import { BaseCustomResponseParams } from "../../BaseCustomResponse";
import CustomDefaultDeleteResponse from "./CustomDefaultDeleteResponse";

type CustomResponseConstructor = new (
  params: BaseCustomResponseParams
) => BaseCustomDeleteResponse;

const MapStoreWithCustomRequest: { [key: string]: CustomResponseConstructor } =
  {
    [StoreName.TASK_TYPES]: CustomResponseTaskType,
  };

export default class FactoryCustomDeleteResponse {
  static getResponseHandler(
    params: BaseCustomResponseParams
  ): BaseCustomDeleteResponse {
    const { event } = params;
    const url = event.request.url;
    if (url.includes(SERVER_ORIGIN)) {
      const storeName = params.storeNameOfRequest;
      const CustomResponseHandler =
        MapStoreWithCustomRequest[storeName] || BaseCustomDeleteResponse;

      return new CustomResponseHandler(params);
    }

    return new CustomDefaultDeleteResponse(params);
  }
}
